import { addSpaceDelegation, banWallet, burnZeroEth, checkIn, clearChannelPermissionOverrides, createChannel, createLegacySpace, createRole, createSpace, deleteRole, editMembership, enableGuardian, disableGuardian, transferOwnership, joinSpace, legacyCreateRole, legacyEditMembership, legacyUpdateRole, linkEOA, linkSmartAccount, linkSmartAccountAndEOAAndSetDefaultWallet, refreshMetadata, removeLink, review, setChannelPermissionOverrides, tip, transferAssets, transferERC20, transferEth, unbanWallet, updateChannel, updateRole, updateSpaceInfo, upgradeToAndCall, withdrawSpaceFunds, } from './operations';
import { stakeToTowns } from './operations/stakeToTown';
import { increaseStakeToTowns } from './operations/increaseStakeToTown';
import { redelegateStake } from './operations/redelegateStakeToTown';
import { executeSwap } from './operations/executeSwap';
import { renewMembership } from './operations/renewMembership';
import { claimReward } from './operations/claimReward';
import { initiateWithdrawDeposit } from './operations/initiateWithdrawDeposit';
import { withdrawDeposits } from './operations/withdrawDeposits';
import { zeroAddress } from 'viem';
import { installApp } from './operations/installApp';
import { createApp } from './operations/createApp';
import { registerApp } from './operations/registerApp';
import { updateAppPricing } from './operations/updateAppPricing';
import { withdrawAppFunds } from './operations/withdrawAppFunds';
import { promoteAgent } from './operations/promoteAgent';
import { claimRewardAndStakeToTown } from './operations/claimRewardAndStakeToTown';
import { claimRewardAndIncreaseStakeToTown } from './operations/claimRewardAndIncreaseStakeToTown';
import { uninstallApp } from './operations/uninstallApp';
import { updateAppPermissions } from './operations/updateAppPermissions';
import { updateApp } from './operations/updateApp';
import { renewApp } from './operations/renewApp';
import { giveBotFeedback } from './operations/giveBotFeedback';
import { installAccountModulesAndApp } from './operations/installAccountModulesAndApp';
import { SmartAccountSession } from './lib/SmartAccountSession';
export class UserOps {
    smartAccountSession;
    spaceDapp;
    timeTracker;
    appRegistryDapp;
    constructor(config) {
        if (!config.newAccountImplementationType) {
            throw new Error('newAccountImplementationType is required');
        }
        this.smartAccountSession = new SmartAccountSession({
            aaRpcUrl: config.aaRpcUrl,
            bundlerUrl: config.bundlerUrl ?? '',
            paymasterProxyUrl: config.paymasterProxyUrl,
            paymasterProxyAuthSecret: config.paymasterProxyAuthSecret,
            spaceDapp: config.spaceDapp,
            fetchAccessTokenFn: config.fetchAccessTokenFn,
            newAccountImplementationType: config.newAccountImplementationType,
            forceSmartAccountAddress: config.forceSmartAccountAddress,
            forceSmartAccountType: config.forceSmartAccountType,
            usePimlicoPaymaster: config.usePimlicoPaymaster,
            enableUsdc: config.enableUsdc,
        });
        this.spaceDapp = config.spaceDapp;
        this.appRegistryDapp = config.appRegistryDapp;
        this.timeTracker = config.timeTracker;
    }
    async sendPromoteAgentOp(args) {
        return promoteAgent({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async commonParams(signer) {
        const smartAccountSessionConfig = this.smartAccountSession.getConfig();
        if (!smartAccountSessionConfig.paymasterProxyUrl ||
            !smartAccountSessionConfig.paymasterProxyAuthSecret) {
            throw new Error('paymasterProxyUrl and paymasterProxyAuthSecret are required');
        }
        const smartAccount = await this.smartAccountSession.getSmartAccount({ signer });
        return {
            spaceDapp: this.spaceDapp,
            appRegistryDapp: this.appRegistryDapp,
            timeTracker: this.timeTracker,
            aaRpcUrl: smartAccountSessionConfig.aaRpcUrl,
            paymasterProxyUrl: smartAccountSessionConfig.paymasterProxyUrl,
            paymasterProxyAuthSecret: smartAccountSessionConfig.paymasterProxyAuthSecret,
            newAccountImplementationType: smartAccountSessionConfig.newAccountImplementationType,
            smartAccount,
        };
    }
    // public async dropAndReplace(hash: string, signer: ethers.Signer) {
    //     const sender = (await this.smartAccountSession.getClient({ signer })).address
    //     const userOpState = selectUserOpsByAddress(sender, userOpsStore.getState())
    //     if (!userOpState) {
    //         throw new Error('current user op not found')
    //     }
    //     const pending = userOpState.pending
    //     if (!pending.op?.callData) {
    //         throw new Error('user op call data not found')
    //     }
    //     if (pending.hash !== hash) {
    //         throw new Error('user op hash does not match')
    //     }
    //     if (!pending.functionHashForPaymasterProxy) {
    //         throw new Error('user op function hash for paymaster proxy not found')
    //     }
    //     const pendingDecodedCallData = decodeCallData({
    //         callData: pending.op.callData,
    //         functionHash: pending.functionHashForPaymasterProxy,
    //     })
    //     const spaceId = pending.spaceId
    //     const functionHashForPaymasterProxy = pending.functionHashForPaymasterProxy
    //     if (isBatchData(pendingDecodedCallData)) {
    //         const { toAddress, value, executeData } = pendingDecodedCallData
    //         return this.sendUserOp({
    //             toAddress,
    //             callData: executeData,
    //             signer,
    //             spaceId,
    //             functionHashForPaymasterProxy,
    //             value,
    //         })
    //     } else if (isSingleData(pendingDecodedCallData)) {
    //         const { toAddress, value, executeData } = pendingDecodedCallData
    //         return this.sendUserOp({
    //             toAddress,
    //             callData: executeData,
    //             signer,
    //             spaceId,
    //             functionHashForPaymasterProxy,
    //             value,
    //         })
    //     } else {
    //         throw new Error('mismatch in format of toAddress and callData')
    //     }
    // }
    async sendUpgradeToAndCallOp(args) {
        const commonParams = await this.commonParams(args.signer);
        return upgradeToAndCall({
            ...commonParams,
            signer: args.signer,
        });
    }
    async sendCreateLegacySpaceOp(args) {
        const commonParams = await this.commonParams(args[1]);
        return createLegacySpace({
            ...commonParams,
            fnArgs: args,
            entryPointAddress: commonParams.smartAccount.entrypointAddress,
            factoryAddress: commonParams.smartAccount.factoryAddress,
        });
    }
    async sendCreateSpaceOp(args) {
        const commonParams = await this.commonParams(args[1]);
        return createSpace({
            ...commonParams,
            fnArgs: args,
            entryPointAddress: commonParams.smartAccount.entrypointAddress,
            factoryAddress: commonParams.smartAccount.factoryAddress,
        });
    }
    /**
     * Join a space, potentially linking a wallet if necessary
     */
    async sendJoinSpaceOp(args) {
        const commonParams = await this.commonParams(args[2]);
        return joinSpace({
            ...commonParams,
            fnArgs: args,
            entryPointAddress: commonParams.smartAccount.entrypointAddress,
            factoryAddress: commonParams.smartAccount.factoryAddress,
        });
    }
    /**
     * User operation to link smart account wallet to the root key.
     * @param args
     */
    async sendLinkSmartAccountToRootKeyOp(rootKeySigner, abstractAccountAddress, sequenceName) {
        return linkSmartAccount({
            ...(await this.commonParams(rootKeySigner)),
            rootKeySigner,
            abstractAccountAddress,
            sequenceName,
        });
    }
    /**
     * User operation to link an EOA (NOT smart account) wallet to the root key.
     *
     * @param args
     * @returns
     */
    async sendLinkEOAToRootKeyOp(args) {
        return linkEOA({
            ...(await this.commonParams(args[0])),
            fnArgs: args,
        });
    }
    async sendLinkSmartAccountAndEOAAndSetDefaultWalletOp(args) {
        const { rootKeySigner, smartAccountAddress, externalWalletSigner } = args;
        return linkSmartAccountAndEOAAndSetDefaultWallet({
            ...(await this.commonParams(rootKeySigner)),
            rootKeySigner,
            smartAccountAddress,
            externalWalletSigner,
        });
    }
    async sendRemoveWalletLinkOp(args) {
        return removeLink({
            ...(await this.commonParams(args[0])),
            fnArgs: args,
        });
    }
    async sendUpdateSpaceInfoOp(args) {
        return updateSpaceInfo({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendCreateChannelOp(args) {
        const signer = args[5];
        return createChannel({
            ...(await this.commonParams(signer)),
            fnArgs: args,
        });
    }
    async sendUpdateChannelOp(args) {
        return updateChannel({
            ...(await this.commonParams(args[1])),
            fnArgs: args,
        });
    }
    async sendLegacyCreateRoleOp(args) {
        return legacyCreateRole({
            ...(await this.commonParams(args[5])),
            fnArgs: args,
        });
    }
    async sendCreateRoleOp(args) {
        return createRole({
            ...(await this.commonParams(args[5])),
            fnArgs: args,
        });
    }
    async sendDeleteRoleOp(args) {
        return deleteRole({
            ...(await this.commonParams(args[2])),
            fnArgs: args,
        });
    }
    async sendUpdateRoleOp(args) {
        return updateRole({
            ...(await this.commonParams(args[1])),
            fnArgs: args,
        });
    }
    async sendSetChannelPermissionOverridesOp(args) {
        return setChannelPermissionOverrides({
            ...(await this.commonParams(args[1])),
            fnArgs: args,
        });
    }
    async sendClearChannelPermissionOverridesOp(args) {
        return clearChannelPermissionOverrides({
            ...(await this.commonParams(args[1])),
            fnArgs: args,
        });
    }
    async sendLegacyUpdateRoleOp(args) {
        return legacyUpdateRole({
            ...(await this.commonParams(args[1])),
            fnArgs: args,
        });
    }
    async sendBanWalletAddressOp(args) {
        return banWallet({
            ...(await this.commonParams(args[2])),
            fnArgs: args,
        });
    }
    async sendUnbanWalletAddressOp(args) {
        return unbanWallet({
            ...(await this.commonParams(args[2])),
            fnArgs: args,
        });
    }
    async sendEditMembershipSettingsOp(args) {
        return editMembership({
            ...(await this.commonParams(args.signer)),
            spaceId: args.spaceId,
            updateRoleParams: args.updateRoleParams,
            membershipParams: args.membershipParams,
            signer: args.signer,
        });
    }
    async sendLegacyEditMembershipSettingsOp(args) {
        return legacyEditMembership({
            ...(await this.commonParams(args.signer)),
            spaceId: args.spaceId,
            legacyUpdateRoleParams: args.legacyUpdateRoleParams,
            membershipParams: args.membershipParams,
            signer: args.signer,
        });
    }
    async sendTransferEthOp(transferData, signer) {
        return transferEth({
            ...(await this.commonParams(signer)),
            transferData,
            signer,
        });
    }
    async sendTransferERC20Op(args) {
        const { recipient, amount, signer, contractAddress } = args;
        if (contractAddress === zeroAddress) {
            throw new Error('No transferring ERC20s to zero address');
        }
        return transferERC20({
            recipient,
            amount,
            signer,
            contractAddress,
            ...(await this.commonParams(args.signer)),
        });
    }
    /**
     * User operation to burn 0 ETH.
     * This is used to deploy an account.
     * @param signer
     * @returns
     */
    async sendZeroBurnOp(signer) {
        return burnZeroEth({
            ...(await this.commonParams(signer)),
            signer,
        });
    }
    async sendWithdrawSpaceFundsOp(args) {
        return withdrawSpaceFunds({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendTransferAssetsOp(transferData, signer) {
        const commonParams = await this.commonParams(signer);
        return transferAssets({
            ...commonParams,
            transferData,
            signer,
            client: commonParams.smartAccount.publicRpcClient,
        });
    }
    async refreshMetadata(args) {
        return refreshMetadata({
            ...(await this.commonParams(args[1])),
            fnArgs: args,
        });
    }
    async sendTipOp(args) {
        return tip({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendCheckInOp(args) {
        return checkIn({
            ...(await this.commonParams(args[0])),
            fnArgs: args,
        });
    }
    async sendReviewOp(args) {
        return review({
            ...(await this.commonParams(args[1])),
            fnArgs: args,
        });
    }
    async sendAddSpaceDelegationOp(args) {
        return addSpaceDelegation({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async renewMembership(args) {
        const { tokenId, signer, spaceId, subscriptionConfig } = args;
        return renewMembership({
            ...(await this.commonParams(signer)),
            tokenId,
            signer,
            spaceId,
            subscriptionConfig,
        });
    }
    async sendInitiateWithdrawOp(args) {
        const { depositIds, signer } = args;
        return initiateWithdrawDeposit({
            ...(await this.commonParams(signer)),
            depositIds,
            signer,
        });
    }
    async sendWithdrawOp(args) {
        const { depositIds, signer } = args;
        return withdrawDeposits({
            ...(await this.commonParams(signer)),
            depositIds,
            signer,
        });
    }
    async claimReward(args) {
        const { beneficiary, recipient, signer } = args;
        return claimReward({
            ...(await this.commonParams(signer)),
            beneficiary,
            recipient,
            signer,
        });
    }
    async sendStakeToTownOp(args) {
        return stakeToTowns({
            ...(await this.commonParams(args.signer)),
            fnArgs: { ...args },
        });
    }
    async sendClaimRewardAndStakeToTownOp(args) {
        return claimRewardAndStakeToTown({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendClaimRewardAndIncreaseStakeToTownOp(args) {
        return claimRewardAndIncreaseStakeToTown({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendRedelegateStakeOp(args) {
        return redelegateStake({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendIncreaseStakeToTownOp(args) {
        return increaseStakeToTowns({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendCreateAppOp(args) {
        return createApp({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendInstallAppOp(args) {
        const targetType = args.targetType ?? 'space';
        const targetAddress = args.targetAddress ?? args.spaceAddress;
        if (!targetAddress) {
            throw new Error('Either spaceAddress or targetAddress is required');
        }
        return installApp({
            ...(await this.commonParams(args.signer)),
            fnArgs: targetType === 'space'
                ? {
                    target: 'space',
                    spaceAddress: targetAddress,
                    appAddress: args.appAddress,
                    price: args.price,
                    signer: args.signer,
                }
                : {
                    target: 'userAccount',
                    userAddress: targetAddress,
                    appAddress: args.appAddress,
                    price: args.price,
                    signer: args.signer,
                },
        });
    }
    async sendInstallAccountModulesAndAppOp(args) {
        if (!this.appRegistryDapp) {
            throw new Error('appRegistryDapp not initialized');
        }
        if (!this.spaceDapp) {
            throw new Error('spaceDapp not initialized');
        }
        const smartAccount = await this.smartAccountSession.getSmartAccount({ signer: args.signer });
        return installAccountModulesAndApp({
            smartAccount,
            signer: args.signer,
            accountModulesAddress: args.accountModulesAddress,
            appRegistryDapp: this.appRegistryDapp,
            spaceDapp: this.spaceDapp,
            appAddress: args.appAddress,
            price: args.price,
        });
    }
    async sendGiveBotFeedbackOp(args) {
        return giveBotFeedback({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendUninstallAppOp(args) {
        return uninstallApp({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendUpdateAppPricingOp(args) {
        return updateAppPricing({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendUpdateAppPermissionsOp(args) {
        return updateAppPermissions({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendUpdateAppOp(args) {
        return updateApp({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendWithdrawAppFundsOp(args) {
        return withdrawAppFunds({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendRenewAppOp(args) {
        return renewApp({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendRegisterAppOp(args) {
        return registerApp({
            ...(await this.commonParams(args.signer)),
            fnArgs: args,
        });
    }
    async sendExecuteSwapOp(params) {
        const { spaceDapp, smartAccount } = await this.commonParams(params.signer);
        return executeSwap({
            ...params,
        }, spaceDapp, smartAccount);
    }
    async enableGuardian(params) {
        return enableGuardian({
            ...(await this.commonParams(params.signer)),
            fnArgs: { ...params },
        });
    }
    async disableGuardian(params) {
        return disableGuardian({
            ...(await this.commonParams(params.signer)),
            fnArgs: { ...params },
        });
    }
    async transferOwnership(params) {
        return transferOwnership({
            ...(await this.commonParams(params.signer)),
            fnArgs: { ...params },
        });
    }
    async isAccountModulesInstalled(signer) {
        const smartAccount = await this.smartAccountSession.getSmartAccount({ signer });
        // If isAppInstalled function exists (doesn't revert), AccountModules are installed
        // We don't care about the return value, just whether the function exists
        try {
            await smartAccount.publicRpcClient.readContract({
                address: smartAccount.address,
                abi: [
                    {
                        name: 'isAppInstalled',
                        type: 'function',
                        inputs: [{ name: 'app', type: 'address' }],
                        outputs: [{ name: '', type: 'bool' }],
                        stateMutability: 'view',
                    },
                ],
                functionName: 'isAppInstalled',
                args: [zeroAddress],
            });
            // If we get here without throwing, the function exists -> AccountModules installed
            return true;
        }
        catch {
            // Function doesn't exist -> AccountModules not installed
            return false;
        }
    }
}
